import * as PIXI from "pixi.js";
import Tween from "tween.ts";
import Animation from "./Animation";

export default class PrizePopupAnimation extends Animation {
  constructor(PrizePopup: PIXI.Container, size: number, onComp: () => void) {
    super();
    new Tween.Tween(PrizePopup.children[0])
      .to({width:size, height:size}, 500)
      .easing(Tween.Easing.Bounce.Out)
      .onComplete(() => onComp())
      .start();

  }
}